import { Controller } from '@hotwired/stimulus'

// Scrollspy for the public proposal's table of contents: highlights the TOC
// link whose section is currently in view. Sections are the elements tagged
// as section targets (each with an id); links point at them via href="#id".
export default class extends Controller {
  static targets = ['link', 'section']

  connect() {
    this.observer = new IntersectionObserver(
      (entries) => this.update(entries),
      // A narrow band near the top of the viewport decides the active
      // section, so it flips as each section header scrolls past.
      { rootMargin: '-15% 0px -75% 0px' }
    )
    this.sectionTargets.forEach((section) => this.observer.observe(section))
  }

  disconnect() {
    this.observer?.disconnect()
  }

  update(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) this.activate(entry.target.id)
    })
  }

  activate(id) {
    this.linkTargets.forEach((link) => {
      link.classList.toggle('active', link.getAttribute('href') === `#${id}`)
    })
  }
}
